// extracted by mini-css-extract-plugin
export default {"typingWrapper":"typing-indicator_typingWrapper__H3AOt"};